<template>
  <div>
    <div class="row">
      <div
        class="col-xs-6 col-sm-6 col-md-4 col-lg-3 mb-4"
        v-for="photo in photos"
        :key="`${photo.id}`"
      >
        <div>
          <div class="uploader ready illustrator-container image-container">
            <div
              class="upload-drop-site upload-drop-site-wrapper"
              :id="photo.id"
            >
              <div class="handler position-relative">
                <template>
                  <div class="position-relative preview-wrapper">
                    <div class="preview">
                      <VPhotoPreview
                        :image="photo.file"
                        :loading="photo.loading"
                        :type="photo.type"
                      />
                      <button
                        v-if="!photo.loading"
                        type="button"
                        class="btn remove photo-input__remove-btn"
                        :class="{
                          'photo-input__remove-btn_deleting': photo.deleting
                        }"
                        aria-label="Delete"
                        @mouseup="removePhoto(photo)"
                      >
                        <span class="sr-only">Delete</span>
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-4 col-lg-3 mb-4">
        <div class="uploader ready illustrator-container image-container">
          <div
            class="upload-drop-site upload-drop-site-wrapper"
            :id="'illu-' + id"
          >
            <div class="upload-image-container">
              <div class="image-upload">
                <VPhotoInput
                  ref="carImagesOther"
                  name="carImagesOther"
                  :onInputFiles="onInputFiles"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isCropModalOpen">
      <ImageCropModal
        :imageSrc="imageSrc"
        :closeCurrentModal="closeCurrentModal"
        :uploadFiles="uploadFiles"
        :imageName="imageName"
      />
    </div>
  </div>
</template>
<script>
import { checkImageOrFail } from "@/utils/validation/image";

import {
  createAuctionManagerMixin,
  auctionManagerStore
} from '@/mixins/auctionsManagerMixin'
import ImageCropModal from "@/components/ImageCropModal.vue";
import VPhotoInput from "./Forms/SellCarForm/VPhotoInput.vue";
import VPhotoPreview from "./Forms/SellCarForm/VPhotoPreview.vue";
// import ImageCropModal from "../Modals/ImageCropModal.vue";

export default {
  name: "Images",

  mixins: [createAuctionManagerMixin()],

  components: {
    VPhotoPreview: VPhotoPreview,
    VPhotoInput: VPhotoInput,
    ImageCropModal: ImageCropModal
  },

  props: {
    name: {
      type: String,
      default: ""
    },
    // errorMsg: {
    //   type: String
    // },
    id: {
      type: Number
    },
    carId: {
      type: [Number, null]
    },
    number: {
      type: [Number, null]
    },
    isShowNumber: {
      type: Boolean
    },
    images: {
      type: Array
    },
    imageIds: {
      type: Array
    },
    imageType: {
      type: String
    },
    uploadedImages: { type: Array }
  },

  computed: {},

  data: () => ({
    imageName: null,
    imageSrc: null,
    isCropModalOpen: false,
    isActiveDragEvent: false,
    photos: [],
    errorList: [],
    allFilesCount: 1,
    morePhotos: 0,
    showError: false,
    isQrCodeShow: false
  }),

  methods: {
    closeCurrentModal() {
      this.isCropModalOpen = false;
      this.imageName = null;
    },
    qrCodeModelToggle() {
      this.isQrCodeShow = !this.isQrCodeShow;
    },
    getImage(id) {
      return `https://evbids.blob.core.windows.net/assets/images/illustrator${id}.svg`;
    },
    onInputFiles(e) {
      const file = e.target.files[0];
      this.imageName = file.name;
      if (file) {
        // Read the selected image file and set it as the cropper source
        const reader = new FileReader();
        reader.onload = () => {
          this.imageSrc = reader.result;
          this.isCropModalOpen = true;
        };
        reader.readAsDataURL(file);
      }
      // this.uploadFiles(e.target.files);
    },
    async uploadFiles(files) {
      this.isCropModalOpen = false;
      this.imageName = null;
      for (let idx = 0; idx < Array.from(files).length; idx++) {
        try {
          checkImageOrFail(files[idx]);
          const newPhoto = {
            id: this.photos.length + 1,
            file: files[idx],
            loading: true,
            deleting: false,
            result: null,
            type: "file"
          };
          this.photos.push(newPhoto);
          this[auctionManagerStore.actionTypes.ACTION_ADD_PHOTO_TO_JOINED_CAR]({
            idx: newPhoto.id,
            file: files[idx],
            name: this.imageType,
            carId: this.carId
          })
            .then(({ arrId, uploadImageId, data }) => {
              console.log("arrId", uploadImageId);
              debugger;
              const index = this.photos.findIndex(f => f.id == arrId);
              // eslint-disable-next-line vue/no-mutating-props
              this.images.push({
                id: uploadImageId,
                uploadImageId: uploadImageId,
                image: files[idx],
                type: this.imageType,
                imageType: "file"
              });
              this.photos.splice(index, 1, {
                ...this.photos[index],
                result: data,
                // file: files[idx],
                type: "file",
                loading: false
              });
            })
            .catch(err => {
              const index = this.photos.findIndex(f => f.id === this.id);
              if (index > -1) {
                this.photos.splice(index, 1);
              }
            });
        } catch (error) {
          this.pushError(error.message);
        }
      }

      this.$emit("input", files);
    },
    hasLoadingPhotos() {
      return this.photos.some(p => p.loading);
    },

    getFileId() {
      this.allFilesCount = 1;
      return this.allFilesCount;
    },

    pushError(errorText) {
      this.errorList.push(errorText);

      setTimeout(() => {
        this.removeItemFromArray(this.errorList, errorText);
      }, 5000);
    },

    async removePhoto(photo) {
      if (!photo.result || !photo.result.id || photo.deleting) return;
      photo.deleting = true;
      await this[auctionManagerStore.actionTypes.ACTION_REMOVE_CAR_PHOTO]({
        imageId: photo.result.id
      });
      photo.deleting = false;
      this.removeItemFromArray(this.photos, photo, true);
      let cloneImage = [...this.images]
      let findIndex = cloneImage.findIndex(x =>x.id === this.id);
      if(findIndex > -1){
        cloneImage.splice(findIndex, 1)
        // eslint-disable-next-line vue/no-mutating-props
        this.images = cloneImage
      }
    },

    removeItemFromArray(array, item, isPhoto) {
      const itemIndex = isPhoto
        ? array.findIndex(_item => _item.id === item.id)
        : array.indexOf(item);

      if (itemIndex >= 0) {
        array.splice(itemIndex, 1);
      }
    }
  },
  mounted() {
    console.log("uploadedImages", this.uploadedImages);
    if(this.uploadedImages && this.uploadedImages.length > 0){
      for(let i =0; i < this.uploadedImages.length; i++){
           // eslint-disable-next-line vue/no-mutating-props
          this.images.push({id: this.id, uploadImageId: this.uploadedImages[i].id, image: this.uploadedImages[i].url, type: this.imageType, imageType: 'url'})
          const newPhoto = {
            id: this.uploadedImages[i].id,
            file:this.uploadedImages[i].url,
            loading: false,
            deleting: false,
            type: 'url',
            result: this.uploadedImages[i]
          };
          this.photos.push(newPhoto);
          console.log("this.photos",this.photos)

      }
      console.log("mounted", this.photos)
    }
  }
};
</script>
<style>
.photo-input__remove-btn {
  z-index: 3;
}

.photo-input__remove-btn_deleting::after {
  margin-top: 0 !important;
  background: none !important;
  width: calc(100% - 4px) !important;
  height: calc(100% - 4px) !important;
  border: solid;
  border-radius: 50em;
  border-right: 0.25em solid white;
  animation: spinner-border 0.75s linear infinite;
}
.illustrator-container .upload-drop-site.upload-drop-site-wrapper {
  border-radius: 15px;
  border: 1px solid #dddddd !important;
  height: 198px;
  background: #fff;
}
.illustration-image-number-container {
  top: 7px;
  left: 7px;
  background: black;
  color: #fff;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  text-align: center;
}
.illustration-image-number-container span {
  vertical-align: text-top;
}
.upload-image-container {
  display: flex;
  justify-content: space-between;
  background-color: #f0f0f0;
  border-radius: 8px;
  position: absolute;
  top: 7px;
  right: 25px;
  display: none;
  padding: 0px, 2px, 0px, 2px;
  margin-right: 18px;
  width: 32px;
  height: 32px;
  z-index: 1;
  @media (max-width: 767px) {
    width: 68px;
    right: 0px;
  }
  @media (max-width: 767px) {
    width: 68px;
    right: 0px;
  }
  @media (max-width: 500px) {
    width: 68px;
    right: 0px;
  }
}
.upload-drop-site:hover .upload-image-container {
  display: flex;
}
.image-upload {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/image-upload-inactive.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center;
}
.image-upload:hover {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/image-upload-active.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-color: #cc0000;
  background-position: center;
  border-radius: 8px;
}
.camera-upload {
  background: url(https://evbids.blob.core.windows.net/assets/images/camera-inactive.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center;
}
.image-upload.camera-upload:hover {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/camera-active.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-color: #e1f3cb;
  background-position: center;
  border-radius: 8px;
}
.image-upload-qrcode {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/camera-inactive.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center;
}
.image-upload-qrcode:hover {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/camera-active.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-color: #e1f3cb;
  background-position: center;
  border-radius: 8px;
}
</style>
